<template>



    <div class="mx-sm-1 mt-9">


        <div class="page-header">
            <h1 class="page-title fw-bold">Cadrage</h1>
            <div>
                <ol class="breadcrumb">
                    <li class="breadcrumb-item"><router-link :to="{ name: 'dashboard' }"><a>Tableau de
                                bord</a></router-link></li>
                    <li class="breadcrumb-item active" aria-current="page"><router-link
                            :to="{ name: 'classeurs' }"><a>Les Cadrages</a></router-link></li>
                </ol>
            </div>
        </div>
        <div class="row">

            <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">

                <div class="modal fade" id="cadrage" tabindex="-1" role="dialog">
                    <div class="modal-dialog modal-fullscreen modal-dialog-scrollable" role="document">
                        <div class="modal-content" style="background-color: #f0f0f5!important;">
                            <div class="modal-header bg-primary text-white">
                                <h6 class="modal-title fw-bold" style="font-size: 16px;">Déclaration de cadrage
                                </h6>
                                <button aria-label="Close" class="btn-close text-white" data-bs-dismiss="modal"
                                    type="button"><span aria-hidden="true">×</span></button>
                            </div>
                            <div class="modal-body">
                                <div class="accordion" id="accordionPanelsStayOpenExample">
                                    <div class="accordion-item ">
                                        <h3 class="accordion-header fw-bold m-3">
                                            <i class="fe fe-tag fs-18 fw-bold"> </i> composante
                                            <a class="accordion-button fw-bold" type="button" data-bs-toggle="collapse"
                                                data-bs-target="#panelsStayOpen-collapseOne" aria-expanded="false"
                                                aria-controls="panelsStayOpen-collapseOne">
                                                {{
                                                    payload?.idComposante?.nomComposante ?
                                                        payload?.idComposante?.nomComposante : '---' }}
                                            </a>
                                        </h3>
                                        <div id="panelsStayOpen-collapseOne" class="accordion-collapse collapse">
                                            <div class="accordion-body">
                                                <div class="row mb-3">


                                                    <div class="col-md-2">
                                                        <div class="card h-100">
                                                            <div class="card-body alert alert-secondary shadow shadow">
                                                                <label for="" class="fw-bold">Date début : </label>
                                                                <p class="card-text fw-bold">
                                                                    <i class="fe fe-tag fs-18"></i> {{
                                                                        formatDate(payload?.idComposante?.dateFinPlanifiee)
                                                                    }}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="col-md-2">
                                                        <div class="card h-100">
                                                            <div class="card-body alert alert-secondary shadow shadow">
                                                                <label for="" class="fw-bold">Date fin : </label>
                                                                <p class="card-text fw-bold">
                                                                    <i class="fe fe-tag fs-18"></i> {{
                                                                        formatDate(payload?.idComposante?.dateDebutPlanifiee)
                                                                    }}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-8">
                                                        <div class="card h-100">
                                                            <div class="card-body alert alert-secondary shadow shadow">
                                                                <label for="" class="fw-bold">Sous projet : </label>
                                                                <p class="card-text fw-bold">
                                                                    <i class="fe fe-tag fs-18"></i> {{
                                                                        payload?.idComposante?.idSsProjPag?.nomSsProjPag }}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row mb-3">
                                                    <div class="col-md-6">
                                                        <div class="card h-100">
                                                            <div class="card-body alert alert-secondary shadow shadow">
                                                                <label for="" class="fw-bold">Projet : </label>
                                                                <p class="card-text fw-bold">
                                                                    <i class="fe fe-tag fs-18"></i> {{
                                                                        payload?.idComposante?.idSsProjPag?.idProjetPag?.nomProjetPag
                                                                    }}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="col-md-6">
                                                        <div class="card h-100">
                                                            <div class="card-body alert alert-secondary shadow shadow">
                                                                <label for="" class="fw-bold">Action : </label>
                                                                <p class="card-text fw-bold">
                                                                    <i class="fe fe-tag fs-18"></i> {{
                                                                        payload?.idComposante?.idSsProjPag?.idProjetPag?.actionPag
                                                                    }}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <hr>
                                <div class="row">

                                    <div class="col-sm-12 col-md-12 col-lg-12 col-xl-4">
                                        <div class="card">
                                            <div class="card-body">
                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <div class="form-group">
                                                            <label class="form-label">Année <span
                                                                    class="text-danger">*</span></label>
                                                            <multi-select deselect-label="Sélectionné" select-label=""
                                                                :options="exercices" @select="chargerCadrage"
                                                                placeholder="Sélectionné une année " label="annee"
                                                                track-by="annee" :searchable="true"
                                                                :custom-label="o => o.annee" v-model="payload.annee">
                                                                <template slot="singleLabel" slot-scope="{ option }">
                                                                    <strong> {{ option.annee }}</strong>
                                                                </template>
                                                                <span slot="noOptions">
                                                                    <strong>Liste Vide</strong>
                                                                </span>
                                                                <span slot="noResult">
                                                                    <strong>Aucun Résultat</strong>
                                                                </span>
                                                            </multi-select>

                                                        </div>
                                                    </div>

                                                </div>
                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <div class="form-group">
                                                            <label class="form-label">Montant du cadrage <span
                                                                    class="text-danger">*</span></label>
                                                            <input type="number" class="form-control"
                                                                v-model="payload.montantCpBn">

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-footer my-3 d-flex">
                                                <div class="col-md-6">
                                                    <button @click=saver() class="btn btn-success mt-4 mb-0" :disabled="invalid"
                                                        v-if="save"><span class="fe fe-check"></span>
                                                        Enregistrer</button>
                                                    <button class="btn btn-success mt-4 mb-0" :disabled="invalid"
                                                        v-else><span class="fe fe-check"></span>
                                                        Modifier</button>
                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-sm-12 col-md-12 col-lg-12 col-xl-8">
                                        <div class="card">
                                            <div class="card-body">

                                                <table
                                                    class="table table-hover table-bordered text-nowrap border-bottom mb-0"
                                                    id="my">
                                                    <thead class="border-top success02">
                                                        <tr class="fw-bold">
                                                            <th class="bg-transparent border-bottom-0 fw-bold"
                                                                style="width: 5%;" @click="sortBy('idClasseur')">Id</th>
                                                            <th class="bg-transparent border-bottom-0 fw-bold"
                                                                @click="sortBy('nomClasseur')">Année
                                                            </th>
                                                            <th class="bg-transparent border-bottom-0 fw-bold"
                                                                style="width: 10%;" @click="sortBy('createdAt')">Montant
                                                                CP
                                                                BN
                                                            </th>
                                                            <!-- <th class="bg-transparent border-bottom-0 fw-bold" style="width: 30%;" @click="sortBy('auteur')">
                                                        Auteur</th> -->
                                                            <th class="bg-transparent border-bottom-0 fw-bold"
                                                                style="width: 5%;">Actions
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody v-if="cadrages.length > 0" id="myTable1">

                                                        <!-- Ligne principale -->
                                                        <tr v-for="(item, index) in cadrages" class="border-bottom"
                                                            style="background-color: cornflowerblue;">
                                                            <td>
                                                                <span class="fw-bold">{{ item?.actionPag }}</span>
                                                            </td>
                                                            <td>
                                                                <span class="fw-bold">{{ item?.actionPag }}</span>
                                                            </td>
                                                            <td>
                                                                <span class="fw-bold">{{ item?.actionPag }}</span>
                                                            </td>
                                                            <td>
                                                                <button class="btn btn-warning btn-sm text-white"
                                                                    @click.prevent="toggleDetail(item)">
                                                                    <span class="fe fe-edit fs-18"></span>
                                                                </button>
                                                                <button class="btn btn-warning btn-sm text-white"
                                                                    @click.prevent="toggleDetail(item)">
                                                                    <span class="fe fe-eye fs-18"></span>
                                                                </button>
                                                            </td>
                                                        </tr>



                                                    </tbody>


                                                    <tbody v-else>
                                                        <tr class="primary02">
                                                            <td colspan="4" class="text-center">Aucun cadrage trouvé
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>

                                        </div>
                                    </div>
                                </div>


                            </div>
                            <div class="modal-footer">
                                <button class="btn btn-gray" data-bs-dismiss="modal">Fermer</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-header">
                        <h3 class="card-title fw-bold">Ecran de cadrage</h3>
                        <div class="card-options">
                            <SearchInputAll></SearchInputAll>
                           

                        </div>
                    </div>
                    <div class="card-body">
                        <div class="table-responsive">
                            <table class="table table-hover table-bordered text-nowrap border-bottom mb-0" id="my">
                                <thead class="border-top success02">
                                    <tr class="fw-bold">
                                        <th class="bg-transparent border-bottom-0 fw-bold" style="width: 5%;"
                                            @click="sortBy('idClasseur')">Action et projet</th>
                                        <th class="bg-transparent border-bottom-0 fw-bold"
                                            @click="sortBy('nomClasseur')">
                                        </th>
                                        <th class="bg-transparent border-bottom-0 fw-bold" style="width: 10%;"
                                            @click="sortBy('createdAt')">
                                        </th>
                                        <!-- <th class="bg-transparent border-bottom-0 fw-bold" style="width: 30%;" @click="sortBy('auteur')">
                                        Auteur</th> -->
                                        <th class="bg-transparent border-bottom-0 fw-bold" style="width: 5%;">Actions
                                        </th>
                                    </tr>
                                </thead>
                                <tbody v-if="donnees.length > 0" id="myTable1">
                                    <template v-for="(item, index) in donnees">
                                        <!-- Ligne principale -->
                                        <tr class="border-bottom" style="background-color: cornflowerblue;">
                                            <td colspan="3">
                                                <p class="fw-bold text-break" style="max-width: 320px;">{{ item.actionPag }}</p>
                                            </td>
                                            <td>
                                                <button class="btn btn-warning btn-sm text-white"
                                                    @click.prevent="toggleDetail(item)">
                                                    <span class="fe fe-eye fs-18"></span>
                                                </button>
                                            </td>
                                        </tr>

                                        <!-- Composantes, affichées uniquement si item sélectionné -->
                                        <tr v-for="(compo, idx) in item.composantes" :key="`compo-${index}-${idx}`"
                                            v-if="selectedItem === item">
                                            <td colspan="3">{{ compo.nomComposante }}</td>
                                            <td> <button class="btn btn-primary btn-sm text-white"
                                                    @click.prevent="edit(compo)">
                                                    <span class="fe fe-edit fs-18"></span>
                                                </button>
                                            </td>
                                        </tr>
                                    </template>
                                </tbody>


                                <tbody v-else>
                                    <tr class="primary02">
                                        <td colspan="5" class="text-center">Aucune information trouvé</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <nav v-if="pageCount > 1" class="mt-2">
                            <ul class="pagination justify-content-end">
                                <li class="page-item" :class="{ disabled: currentPage === 1 }">
                                    <a class="page-link" href="#"
                                        @click.prevent="changePage(currentPage - 1)">&laquo;</a>
                                </li>
                                <li v-for="page in pageCount" :key="page" class="page-item"
                                    :class="{ active: currentPage === page }">
                                    <a class="page-link" href="#" @click.prevent="changePage(page)">{{ page }}</a>
                                </li>
                                <li class="page-item" :class="{ disabled: currentPage === pageCount }">
                                    <a class="page-link" href="#"
                                        @click.prevent="changePage(currentPage + 1)">&raquo;</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
       
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { reduce } from "lodash";
import $ from 'jquery';
import { query } from 'vue-gtag';
export default {
    name: "Cadrage",
    data() {
        return {
            loading: false, composantes: {}, exercices: {}, cadrages: {},
            payload: { idComposante: null }, save: true, id: '', donnees: {}, selectedItem: null, form: false,
            currentPage: 1,
            perPage: 10,
            currentSort: 'idClasseur',
            currentSortDir: 'asc'
        }
    },
    computed: {
        ...mapGetters({ items: 'classeurs/list' }),
        sortedItems() {
            return [...this.items].sort((a, b) => {
                const aVal = this.resolveSortValue(a);
                const bVal = this.resolveSortValue(b);
                if (this.currentSortDir === 'asc') {
                    return aVal > bVal ? 1 : -1;
                } else {
                    return aVal < bVal ? 1 : -1;
                }
            });
        },
        filtersItems() {
            const start = (this.currentPage - 1) * this.perPage;
            return this.sortedItems.slice(start, start + this.perPage);
        },
        pageCount() {
            return Math.ceil(this.items.length / this.perPage);
        }
    },
    mounted() {
    },
    methods: {
        ...mapActions('classeurs', ['all', 'add', 'one', 'del']),
        sortBy(column) {
            if (this.currentSort === column) {
                this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
            } else {
                this.currentSort = column;
                this.currentSortDir = 'asc';
            }
        },
        changePage(page) {
            if (page >= 1 && page <= this.pageCount) {
                this.currentPage = page;
            }
        },
        resolveSortValue(item) {
            const val = item[this.currentSort];
            if (this.currentSort === 'auteur') {
                return item.user?.firstname + ' ' + item.user?.lastname;
            }
            return typeof val === 'string' ? val.toLowerCase() : val;
        }, getExercices() {
            this.$http.get('/exercice')
                .then(({ data }) => {
                    console.log(data);
                    console.log(1);
                    this.exercices = data;

                });
        },
        chargerCadrage() {
            this.$loading(true);
            this.$http.get(`/cadrage/${this.payload.exercice.annee}/${this.payload.idComposante.idComposante}`)
                .then(({ data }) => {
                    console.log(data);
                    console.log(22);
                    this.$loading(false);
                });
        },
        getComposantes() {
            this.$http.get('/composantes')
                .then(({ data }) => {
                    console.log(data);
                    this.composantes = data;
                    this.$loading(false);
                });
        },
        choixComposantes() {

        },
        toggleDetail(item) {
            // Si déjà ouvert, fermer ; sinon, ouvrir
            if (this.selectedItem === item) {
                this.selectedItem = null;
            } else {
                this.selectedItem = item;
            }
        },
        formatDate(dateStr) {
            const date = new Date(dateStr);
            return date.toLocaleDateString('fr-FR', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            });
        },
        onSearch(offset) {
            this.$loading(true);
            if (offset > 0) this.option.page = offset - 1;
            this.$router.push({ query: this.option }).catch(() => { });
            // this.$store.dispatch('classeurs/all', this.option).finally(() => this.$loading(false));
            const params = { ...this.option };
            this.$http.get('/composantes/action', { params })
                .then(response => {
                    // Traitez ici les données de réponse
                    this.donnees = response.data;
                    console.log(this.donnees);

                })
                .catch(error => {
                    console.error('Erreur lors du chargement des données :', error);
                })
                .finally(() => {
                    this.$loading(false);
                });
        },
        saver() {
               this.$http.post('/cadrage', this.payload)
                .then(response => {
                    // Traitez ici les données de réponse
                    this.donnees = response.data;
                    console.log(this.donnees);
                     if(this.donnees){
                        swal('Information!', 'Classeur enregistré avec succès.', 'success');
                        this.onSearch();
                        this.payload = {idComposante: '', montantCpBn: ''};
                    }else {
                        swal('Information!', 'L\enregistrement du classeur n\'a pas pu être effectué.', 'warning');
                    }

                })
                .catch(error => {
                    console.error('Erreur lors du chargement des données :', error);
                })
                .finally(() => {
                    this.$loading(false);
                });
        },
        edit(value) {


            this.payload.idComposante = null;

            //console.log(value);
            this.$loading(true);
            this.save = true;
            this.payload.idComposante = { ...value };
            console.log(this.payload.idComposante)
            this.$loading(false);
          
            $('#cadrage').modal('show');
        },
        drop(item) {

        },
        initializedComposante(item) {

        },
        showform() {

            //  this.form =true;
        }
    },
    created() {
        this.onSearch();
        this.getComposantes();
        this.getExercices();
    }
}
</script>

<style>
th {
    cursor: pointer;
}

.classeur-nom {
    max-width: 220px;
    white-space: normal !important;
    word-wrap: break-word;
    word-break: break-word;
}
</style>